export function mixin(Hop) {
    // Doc https://developers.google.com/analytics/devguides/collection/analyticsjs/events#overview
    Hop.safeGA = function (...args) {
        Hop.gtm.push({category: args[2], action: args[3], label: args[4], value: args[5]});
    };

    Hop.bingTrak = function (data) {
        window.uetq = window.uetq || [];
        window.uetq.push(data);
    };
}
